<app-generic-crud [genericCrud]="genericCRUD"></app-generic-crud>
<router-outlet></router-outlet>
